import { InjectionToken } from '@angular/core';
import { MmI18nConfig } from './i18n-config';

export const MM_I18N_CONFIG_TOKEN = new InjectionToken<MmI18nConfig>("i18 config");